import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const THING_CORE_FIELDS = gql`
  fragment ThingCoreFields on Thing {
    id
    name
    emoji
    value: id
    label: name
  }
`;

export const THING_FIELDS = gql`
  ${THING_CORE_FIELDS}
  fragment ThingFields on Thing {
    ...ThingCoreFields
    parent {
      ...ThingCoreFields
    }
  }
`;

export const THING = gql`
  ${THING_FIELDS}
  query Thing($id: ID!) {
    thing(id: $id) {
      ...ThingFields
    }
  }
`;

export const THINGS = gql`
  ${THING_FIELDS}
  query Things {
    things {
      ...ThingFields
    }
  }
`;

export const SUGGEST_THINGS = gql`
  ${THING_FIELDS}
  query SuggestThings (
    $clientId: ID
    $eventTypeId: ID
    $eventId: ID
    $all: Boolean
  ) {
    things: suggestThings (
      clientId: $clientId
      eventTypeId: $eventTypeId
      eventId: $eventId
      all: $all
    ) {
      ...ThingFields
    }
  }
`;

export const CREATE_THING = gql`
  ${THING_CORE_FIELDS}
  mutation CreateThing ($input: CreateThingInput!) {
    createThing (input: $input) {
      thing {
        ...ThingCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_THING = gql`
  ${THING_CORE_FIELDS}
  mutation UpdateThing ($input: UpdateThingInput!) {
    updateThing (input: $input) {
      thing {
        ...ThingCoreFields
      }
      ${ERRORS}
    }
  }
`;
